import { NgModule } from '@angular/core';
import { RouterModule, Routes } from '@angular/router';
import { SigninComponent } from './components/auth/signin/signin.component';
import { UserPermission } from './enums/enums';
import { AuthGuard } from './services/app/auth-guard/auth.guard';
import { PublicGuard } from './services/app/public-guard/public.guard';
import { UsersListComponent } from './components/user/users-list/users-list.component';
import { AddUserComponent } from './components/user/add-user/add-user.component';
import { ProfileComponent } from './components/profile/profile.component';
import { ListRoleComponent } from './components/role/list-role/list-role.component';
import { AddRoleComponent } from './components/role/add-role/add-role.component';
import { ResetPasswordComponent } from './components/auth/reset-password/reset-password.component';
import { NotificationsComponent } from './components/shared/layout/notifications/notifications.component';
import { PermissionGuard } from './services/app/permission-guard/permission.guard';
import { orderedSyncGuards } from './services/app/order-sequential-guard/orderSequential.guard';
import { QuickbooksListComponent } from './components/quickbooks/quickbooks-list/quickbooks-list.component';
import { AddQuickbooksComponent } from './components/quickbooks/add-quickbooks/add-quickbooks.component';
import { QuickbooksConnectedComponent } from './components/quickbooks/quickbooks-connected/quickbooks-connected.component';
import { EmployeeListComponent } from './components/employee/employee-list/employee-list.component';
import { AddEmployeeComponent } from './components/employee/add-employee/add-employee.component';
import { CustomersListComponent } from './components/customers/customers-list/customers-list.component';
import { AddCustomerComponent } from './components/customers/add-customer/add-customer.component';
import { CompaniesListComponent } from './components/companies/companies-list/companies-list.component';
import { AddCompanyComponent } from './components/companies/add-company/add-company.component';
import { InvoiceListComponent } from './components/Invoices/invoice-list/invoice-list.component';
import { AddInvoiceComponent } from './components/Invoices/add-invoice/add-invoice.component';
import { ProductServiceListComponent } from './components/product-services/product-service-list/product-service-list.component';
import { AddProductServiceComponent } from './components/product-services/add-product-service/add-product-service.component';
import { VendorsListComponent } from './components/vendors/vendors-list/vendors-list.component';
import { AddVendorComponent } from './components/vendors/add-vendor/add-vendor.component';
import { BillListComponent } from './components/bills/bill-list/bill-list.component';
import { AddBillComponent } from './components/bills/add-bill/add-bill.component';
import { PayBillComponent } from './components/bills/pay-bill/pay-bill.component';
import { ReceivePaymentComponent } from './components/Invoices/receive-payment/receive-payment.component';
import { BillPaymentListComponent } from './components/bills/bill-payment-list/bill-payment-list.component';
import { InvoicePaymentListComponent } from './components/Invoices/invoice-payment-list/invoice-payment-list.component';

const routes: Routes = [
  { path: 'login', component: SigninComponent, canActivate: [PublicGuard] },

  { path: '', redirectTo: '/companies', pathMatch: 'full' },

  // profile
  {
    path: 'profile', component: ProfileComponent, canActivate: [AuthGuard],
  },
  // Signups
  {
    path: 'companies',
    component: CompaniesListComponent,
    canActivate: [AuthGuard],
  },
  {
    path: 'companies/add',
    component: AddCompanyComponent,
    canActivate: [AuthGuard],
  },

  {
    path: 'companies/:id/edit',
    component: AddCompanyComponent,
    canActivate: [AuthGuard],
  },


  // quickbooks
  {
    path: 'quickbooks',
    component: QuickbooksListComponent,
    canActivate: [AuthGuard],
  },
  {
    path: 'quickbooks/add',
    component: AddQuickbooksComponent,
    canActivate: [AuthGuard],
  },
  {
    path: 'quickbooks/connected',
    component: QuickbooksConnectedComponent,
    canActivate: [AuthGuard],
  },

  // employee
  {
    path: 'employee',
    component: EmployeeListComponent,
    canActivate: [AuthGuard],
  },
  {
    path: 'employee/add',
    component: AddEmployeeComponent,
    canActivate: [AuthGuard],
  },

  {
    path: 'employee/:id/edit',
    component: AddEmployeeComponent,
    canActivate: [AuthGuard],
  },

  // customer
  {
    path: 'customers',
    component: CustomersListComponent,
    canActivate: [AuthGuard],
  },
  {
    path: 'customers/add',
    component: AddCustomerComponent,
    canActivate: [AuthGuard],
  },
    {
    path: 'customers/:id/edit',
    component: AddCustomerComponent,
    canActivate: [AuthGuard],
  },

  // vendors
  {
    path: 'vendors',
    component: VendorsListComponent,
    canActivate: [AuthGuard],
  },
  {
    path: 'vendors/add',
    component: AddVendorComponent,
    canActivate: [AuthGuard],
  },
  {
    path: 'vendors/:id/edit',
    component: AddVendorComponent,
    canActivate: [AuthGuard],
  },

  // invoices
  {
    path: 'invoices',
    component: InvoiceListComponent,
    canActivate: [AuthGuard],
  },
  {
    path: 'invoices/add',
    component: AddInvoiceComponent,
    canActivate: [AuthGuard],
  },
    {
    path: 'invoices/:id/edit',
    component: AddInvoiceComponent,
    canActivate: [AuthGuard],
  },
  {
    path: 'invoices/:id/receive-payment',
    component: ReceivePaymentComponent,
    canActivate: [AuthGuard],
  },

  // bills
  {
    path: 'bills',
    component: BillListComponent,
    canActivate: [AuthGuard],
  },
  {
    path: 'bills/add',
    component: AddBillComponent,
    canActivate: [AuthGuard],
  },
  {
    path: 'bills/:id/edit',
    component: AddBillComponent,
    canActivate: [AuthGuard],
  },
  {
    path: 'bills/:id/pay',
    component: PayBillComponent,
    canActivate: [AuthGuard],
  },
  {
    path: 'bill-payments',
    component: BillPaymentListComponent,
    canActivate: [AuthGuard],
  },
  {
    path: 'payments',
    component: InvoicePaymentListComponent,
    canActivate: [AuthGuard],
  },


   // product & services
  {
    path: 'services',
    component: ProductServiceListComponent,
    canActivate: [AuthGuard],
  },
  {
    path: 'services/add',
    component: AddProductServiceComponent,
    canActivate: [AuthGuard],
  },
    {
    path: 'services/:id/edit',
    component: AddProductServiceComponent,
    canActivate: [AuthGuard],
  },


  // Users
  {
    path: 'users',
    component: UsersListComponent,
    canActivate: [orderedSyncGuards([AuthGuard, PermissionGuard])],
    data: {
      permissions: [UserPermission.GET_USERS, UserPermission.MANAGE_USERS]
    }
  },
  {
    path: 'users/add',
    component: AddUserComponent,
    canActivate: [orderedSyncGuards([AuthGuard, PermissionGuard])],
    data: {
      permissions: [UserPermission.MANAGE_USERS]
    }
  },
  {
    path: 'users/:userId/edit',
    component: AddUserComponent,
    canActivate: [orderedSyncGuards([AuthGuard, PermissionGuard])],
    data: {
      permissions: [UserPermission.MANAGE_USERS]
    }
  },
  //role:
  {
    path: 'roles',
    component: ListRoleComponent,
    canActivate: [orderedSyncGuards([AuthGuard, PermissionGuard])],
    data: {
      permissions: [UserPermission.GET_ROLE, UserPermission.MANAGE_ROLE]
    }
  },
  {
    path: 'roles/add',
    component: AddRoleComponent,
    canActivate: [orderedSyncGuards([AuthGuard, PermissionGuard])],
    data: {
      permissions: [UserPermission.MANAGE_ROLE]
    }
  },
  {
    path: 'roles/:roleId/edit',
    component: AddRoleComponent,
    canActivate: [orderedSyncGuards([AuthGuard, PermissionGuard])],
    data: {
      permissions: [UserPermission.MANAGE_ROLE]
    }
  },

  {
    path: 'reset-password',
    component: ResetPasswordComponent,
  },
  {
    path: 'notifications',
    component: NotificationsComponent,
    canActivate: [AuthGuard],
  },
];


@NgModule({
  imports: [RouterModule.forRoot(routes)],
  exports: [RouterModule]
})
export class AppRoutingModule { }
